import React from 'react';

const RefreshActionButton = ({
  onClick,
  isLoading = false,
  label = 'Refresh',
  refreshingLabel = 'Refreshing...',
  disabled = false,
  className = '',
  title
}) => {
  const isDisabled = disabled || isLoading;
  const baseClasses = `inline-flex items-center justify-center px-2 py-2 text-xs font-medium rounded-lg border transition-colors focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0 sm:focus:ring-2 sm:focus:ring-blue-500 sm:focus:ring-offset-2 sm:focus-visible:ring-2 sm:focus-visible:ring-blue-500 sm:focus-visible:ring-offset-2 ${
    isDisabled
      ? 'bg-gray-100 text-gray-500 cursor-not-allowed border-gray-200'
      : 'bg-white text-blue-700 border-blue-300 hover:bg-blue-50'
  }`;

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={isDisabled}
      className={`${baseClasses} ${className}`}
      title={title}
      aria-busy={isLoading}
      aria-label={title || label}
    >
      <span className="inline-flex items-center justify-center w-4 h-4 sm:mr-2">
        {isLoading ? (
          <span className="animate-spin inline-block w-4 h-4 border border-blue-500 border-t-transparent rounded-full"></span>
        ) : (
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
            />
          </svg>
        )}
      </span>
      <span className="hidden sm:inline">{isLoading ? refreshingLabel : label}</span>
      <span className="sr-only sm:hidden">{isLoading ? refreshingLabel : label}</span>
    </button>
  );
};

export default RefreshActionButton;